import React from 'react';
import styles from '../../styles/components/page/PageContent.module.css';

export interface PageContentProps {
  noPaddingBottom?: boolean;
  paddingTop?: boolean;
}

const PageContent: React.FC<PageContentProps> = ({
  noPaddingBottom = false,
  paddingTop = false,
  children,
}) => {
  return (
    <div
      className={[
        styles.container,
        noPaddingBottom ? '' : styles.paddingBottom,
        paddingTop ? styles.paddingTop : '',
      ].join(' ')}
    >
      {children}
    </div>
  );
};

export default PageContent;
